/* Souhuka紹介ページ（sections/fp-souhuka-lp.liquid）のスクロール演出。
   [data-scene] は「画面に貼りつく場面」。場面の中をスクロールした割合（0〜1）を --p に入れ、場面ごとの描き方で数字や画面を動かす。
   流れの場面（flow）は4段階: 鍛える → 記録する → ストーリーズを作る → 投稿する。
   [data-reveal] は画面に入ったらふわっと出す。動きを減らす設定の人には、最後の状態をそのまま見せる。
   テスト: node --test scripts/test/souhuka-lp.test.cjs */
(function () {
  'use strict';

  var clamp = function (x) { return x < 0 ? 0 : x > 1 ? 1 : x; };

  // rect: 場面の上端(top)と高さ(height)。vh: 画面の高さ。貼りついている間に進む距離 = 高さ − 画面
  function sceneProgress(rect, vh) {
    var run = rect.height - vh;
    if (run <= 0) return rect.top <= 0 ? 1 : 0;
    return clamp(-rect.top / run);
  }

  var ease = function (p) { return 1 - Math.pow(1 - p, 3); };
  function countTo(target, p) { return Math.round(target * ease(clamp(p))); }

  // 0〜1 を4段階に。最後の段階は1まで含める
  function flowStep(p) {
    var x = clamp(p) * 4;
    var step = Math.min(3, Math.floor(x));
    return { step: step, local: Math.round((x - step) * 1000) / 1000 };
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = { sceneProgress: sceneProgress, countTo: countTo, flowStep: flowStep };
  if (typeof document === 'undefined') return;

  var root = document.getElementById('sk');
  if (!root || root.dataset.init) return;
  root.dataset.init = '1';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fmt = function (n) { return n.toLocaleString('ja-JP'); };
  var seg = function (p, a, b) { return clamp((p - a) / (b - a)); };
  var $ = function (el, s) { return el.querySelector(s); };
  var set = function (el, k, v) { el.style.setProperty(k, v); };

  var draw = {
    hero: function (el, p) {
      var q = ease(seg(p, 0, 0.7));
      set(el, '--rise', q.toFixed(3));
      set(el, '--out', seg(p, 0.55, 1).toFixed(3));
    },
    flow: function (el, p) {
      var f = flowStep(p);
      if (el.dataset.step !== String(f.step)) el.dataset.step = f.step;
      set(el, '--local', f.local.toFixed(3));
      set(el, '--p', p.toFixed(3));
      // 1 鍛える: 回数が1→11（ラットプルダウン 57.5kg × 11回）
      var reps = f.step > 0 ? 11 : Math.max(1, Math.ceil(11 * seg(f.local, 0.05, 0.85)));
      $(el, '[data-k="reps"]').textContent = reps;
      // 2 記録する: 押した瞬間に +2,400kg が飛ぶ
      el.classList.toggle('is-saved', f.step > 1 || (f.step === 1 && f.local > 0.45));
      // 3 ストーリーズ: 文字が1行ずつ組み上がり、合計が数え上がる
      var lines = el.querySelectorAll('[data-line]');
      var shown = f.step > 2 ? lines.length : f.step === 2 ? Math.floor(seg(f.local, 0.05, 0.7) * (lines.length + 1)) : 0;
      Array.prototype.forEach.call(lines, function (x, i) { x.classList.toggle('is-on', i < shown); });
      $(el, '[data-k="story-total"]').textContent = fmt(f.step > 2 ? 5762 : f.step === 2 ? countTo(5762, seg(f.local, 0.55, 0.95)) : 0);
      // 4 投稿する: 送信 → 広がる → いいねが増える
      var post = f.step === 3 ? f.local : 0;
      set(el, '--post', post.toFixed(3));
      el.classList.toggle('is-posted', f.step === 3 && post > 0.25);
      $(el, '[data-k="likes"]').textContent = fmt(countTo(128, seg(post, 0.35, 1)));
      // 投稿後に広がるストーリーズの動画は、その段階に入ったときだけ読み込んで再生する
      var v = $(el, 'video[data-autoplay]');
      var posted = f.step === 3 && post > 0.25;
      if (v && posted && v.paused) { v.preload = 'auto'; var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
      else if (v && !posted && !v.paused) v.pause();
    },
    formula: function (el, p) {
      ['w', 'r', 's'].forEach(function (k, i) { $(el, '[data-f="' + k + '"]').classList.toggle('is-on', p > 0.08 + i * 0.16); });
      var q = seg(p, 0.55, 0.9);
      $(el, '[data-f="eq"]').classList.toggle('is-on', q > 0);
      $(el, '[data-f="total"]').textContent = fmt(countTo(2400, q));
    },
    growth: function (el, p) {
      var q = seg(p, 0.1, 0.8);
      $(el, '[data-g="pct"]').textContent = '+' + (53.2 * ease(q)).toFixed(1) + '%';
      $(el, '[data-g="week"]').textContent = fmt(countTo(10710, q));
      set(el, '--p', p.toFixed(3));
    }
  };

  var scenes = Array.prototype.slice.call(root.querySelectorAll('[data-scene]'));
  function frame() {
    var vh = window.innerHeight;
    scenes.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom < -vh || r.top > vh * 2) return; // 画面から遠い場面は描かない
      var fn = draw[el.dataset.scene];
      if (fn) fn(el, reduce ? 1 : sceneProgress(r, vh));
    });
  }
  var ticking = false;
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(function () { ticking = false; frame(); }); } }
  frame();
  if (!reduce) { window.addEventListener('scroll', onScroll, { passive: true }); window.addEventListener('resize', onScroll); }

  var items = root.querySelectorAll('[data-reveal]');
  if (reduce || !('IntersectionObserver' in window)) {
    Array.prototype.forEach.call(items, function (x) { x.classList.add('is-in'); });
  } else {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -12% 0px' });
    Array.prototype.forEach.call(items, function (x) { io.observe(x); });
  }
})();
